import { Routes } from '@angular/router';
import { LoginPageComponent } from './pages/auth/pages/login-page.component';
import { MainPageComponent } from './pages/main-page.component';
import { authGuard } from './core/auth/auth.guard';
import { guestGuard } from './core/auth/guest.guard';
import { HomeComponent } from './pages/home/home.component';
import { PolicyComponent } from './pages/policy/policy.component';
import { ConfirmEmailComponent } from './pages/confirm-email/confirm-email';
import { NotFound } from './components/not-found/not-found';
import { LandingShellComponent } from './pages/landing-shell.component';
import { ChangePasswordPageComponent } from './pages/auth/pages/change-password-page.component';
import { passwordChangeGuard } from './core/auth/password-change.guard';

export const routes: Routes = [
  {
    path: '',
    component: LandingShellComponent,
    children: [
      { path: '', component: HomeComponent, pathMatch: 'full' },
      { path: 'polityka-prywatnosci', component: PolicyComponent },
      { path: 'confirm-email', component: ConfirmEmailComponent },
    ],
  },
  {
    path: 'app/audit-executions/:planId',
    component: MainPageComponent,
    canActivate: [authGuard],
  },
  { path: 'app', component: MainPageComponent, canActivate: [authGuard] },
  { path: 'login', component: LoginPageComponent, canActivate: [guestGuard] },
  { path: 'change-password', component: ChangePasswordPageComponent, canActivate: [passwordChangeGuard] },
  { path: 'session', redirectTo: 'app' },
  { path: '**', component: NotFound },
];
